module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonerebranding-intro-card1.2.c8a293e1.jpg";